// SurveysData.js
// Data-only file for Surveys.jsx

export const SURVEYS_NAV = [
  { id: "generativeAI", label: "GENERATIVE AI & EDGE INTELLIGENCE" },
  { id: "adversarialML", label: "ADVERSARIAL MACHINE LEARNING" },
  { id: "BTE", label: "BLOCKCHAIN TECHNOLOGIES" },
  { id: "MC", label: "MOBILE CROWDSENSING" },
  { id: "DUC", label: "DRONE / UAV COMMUNICATIONS" },
  { id: "FL", label: "FEDERATED LEARNING" },
  { id: "CSE", label: "COMMUNICATIONS & CYBER SECURITY" },
  { id: "SC", label: "SMART CITIES & AUTONOMOUS TECHNOLOGIES" },
  { id: "DRO", label: "DISASTER RESILIENCE & OPTICAL ACCESS NETWORKS" },
];

/**
 * NOTE:
 * - `paperIsRed: true` means the paper title should be rendered in blue/bold
 *   (this matches your current `styles.publish` behavior).
 * - Keep strings EXACTLY as you wrote them (authors/title/info/bib/doi).
 */
export const SURVEY_SECTIONS = [
  {
    id: "generativeAI",
    title: "GENERATIVE AI & EDGE INTELLIGENCE",
    publications: [
      {
        authors: `M. A. Onsu, P. Lohan, B. Kantarci, B. Kantarci, "`,
        title: `Leveraging Edge Intelligence and LLMs to Advance 6G-Enabled Internet of Automated Defense Vehicles,`,
        info: `" IEEE Internet of Things Magazine ( Volume: 8, Issue: 4, July 2025) `,
        paperIsRed: true,
        bibtex: `@ARTICLE{11048765,
  author={Onsu, Murat Arda and Lohan, Poonam and Kantarci, Burak},
  journal={IEEE Internet of Things Magazine}, 
  title={Leveraging Edge Intelligence and LLMs to Advance 6G-Enabled Internet of Automated Defense Vehicles}, 
  year={2025},
  volume={8},
  number={4},
  pages={148-155},
  keywords={6G mobile communication;Large language models;Decision making;Ultra reliable low latency communication;Real-time systems;Safety;Reliability;Vehicle dynamics;Autonomous vehicles;Optimization;Defense industry},
  doi={10.1109/IOTM.001.2400162}}`,
        bibLabel: "Leveraging Edge Intelligence and LLMs to Advance 6G-Enabled Internet of Automated Defense Vehicles",
        doi: "https://doi.org/10.1109/IOTM.001.2400162",
      },
      {
        authors: `O. Friha, M. Ferrag, B. Kantarci, B. Cakmak, A. Ozgun, N. Ghoualmi-Zine, "`,
        title: `LLM-based Edge Intelligence: A Comprehensive Survey on Architectures, Applications, Security and Trustworthiness,`,
        info: `" IEEE Open Journal of the Communications Society, 2024 `,
        paperIsRed: true,
        bibtex: `@ARTICLE{10669603,
  author={Friha, Othmane and Amine Ferrag, Mohamed and Kantarci, Burak and Cakmak, Burak and Ozgun, Arda and Ghoualmi-Zine, Nassira},
  journal={IEEE Open Journal of the Communications Society}, 
  title={LLM-Based Edge Intelligence: A Comprehensive Survey on Architectures, Applications, Security and Trustworthiness}, 
  year={2024},
  volume={5},
  number={},
  pages={5799-5856},
  keywords={Artificial intelligence;Computational modeling;Security;Robot sensing systems;Technological innovation;Surveys;Real-time systems;Edge intelligence (EI);generative AI;large language models (LLMs);security;privacy;trustworthiness;responsible AI},
  doi={10.1109/OJCOMS.2024.3456549}}`,
        bibLabel: "LLM-Based Edge Intelligence: A Comprehensive Survey on Architectures, Applications, Security and Trustworthiness",
        doi: "https://ieeexplore.ieee.org/abstract/document/10669603",
      },
      {
        authors: ` M. A. Ferrag, O. Friha, B. Kantarci, N. Tihanyi, L. Cordeiro, M. Debbah, D. Hamouda, M. Al-Hawawreh, K-K. Raymond Choo,"`,
        title: `Edge Learning for 6G-enabled Internet of Things: A Comprehensive Survey of Vulnerabilities, Datasets, and Defenses`,
        info: `" IEEE Communications Surveys and Tutorials, vol, 25, issue 4, pp. 2654 2713, Fourth Quarter 2023`,
        paperIsRed: true,
        bibtex: `@ARTICLE{10255264,
  author={Ferrag, Mohamed Amine and Friha, Othmane and Kantarci, Burak and Tihanyi, Norbert and Cordeiro, Lucas and Debbah, Merouane and Hamouda, Djallel and Al-Hawawreh, Muna and Choo, Kim-Kwang Raymond},
  journal={IEEE Communications Surveys & Tutorials}, 
  title={Edge Learning for 6G-Enabled Internet of Things: A Comprehensive Survey of Vulnerabilities, Datasets, and Defenses}, 
  year={2023},
  volume={25},
  number={4},
  pages={2654-2713},
  keywords={6G mobile communication;Security;Internet of Things;Surveys;Peer-to-peer computing;Image edge detection;Federated learning;Edge learning;6G;IoT;federated learning;AI vulnerabilities;security},
  doi={10.1109/COMST.2023.3317242}}`,
        bibLabel: "Edge Learning for 6G-enabled Internet of Things: A Comprehensive Survey of Vulnerabilities, Datasets, and Defenses",
        doi: "https://ieeexplore.ieee.org/document/10255264",
      },
    ],
  },

  {
    id: "adversarialML",
    title: "ADVERSARIAL MACHINE LEARNING",
    publications: [
      {
        authors: `Jinxin Liu, Michele Nogueira, Johan Fernandes and Burak Kantarci, "`,
        title: `Adversarial Machine Learning: A Multilayer Review of the State-of-the-Art and Challenges for Wireless and Mobile Systems,`,
        info: `" in IEEE Communications Surveys & Tutorials, vol. 24, no. 1, pp. 123-159, First Quarter 2022 `,
        paperIsRed: true,
        bibtex: `@ARTICLE{9653662,
  author={Liu, Jinxin and Nogueira, Michele and Fernandes, Johan and Kantarci, Burak},
  journal={IEEE Communications Surveys & Tutorials}, 
  title={Adversarial Machine Learning: A Multilayer Review of the State-of-the-Art and Challenges for Wireless and Mobile Systems}, 
  year={2022},
  volume={24},
  number={1},
  pages={123-159},
  keywords={Wireless communication;Communication system security;Malware;Feature extraction;Wireless sensor networks;Intrusion detection;Generative adversarial networks;Wireless networks;mobile networks;adversarial machine learning;artificial intelligence;intrusion detection},
  doi={10.1109/COMST.2021.3136132}}`,
        bibLabel: "Adversarial Machine Learning: A Multilayer Review of the State-of-the-Art and Challenges for Wireless and Mobile Systems",
        doi: "https://ieeexplore.ieee.org/document/9653662",
      },
      {
        authors: `Comert, C., Gul, O. M., Kulhandjian, M., Touazi, A., Ellement, C., Kantarci, B., & D’Amours, C. (2022). "`,
        title: `Secure Design of Cyber-Physical Systems at the Radio Frequency Level: Machine and Deep Learning-Driven Approaches, Challenges and Opportunities.`,
        info: `" Artificial Intelligence for Cyber-Physical Systems Hardening, 123-154. `,
        paperIsRed: true,
        bibtex: `@Inbook{Comert2023,
	author="Comert, Ceren
	and Gul, Omer Melih
	and Kulhandjian, Michel
	and Touazi, Azzedine
	and Ellement, Cliff
	and Kantarci, Burak
	and D'Amours, Claude",
	editor="Traore, Issa
	and Woungang, Isaac
	and Saad, Sherif",
	title="Secure Design of Cyber-Physical Systems at the Radio Frequency Level: Machine and Deep Learning-Driven Approaches, Challenges and Opportunities",
	bookTitle="Artificial Intelligence for Cyber-Physical Systems Hardening",
	year="2023",
	publisher="Springer International Publishing",
	address="Cham",
	pages="123--154",
	isbn="978-3-031-16237-4",
	doi="10.1007/978-3-031-16237-4_6",
	url="https://doi.org/10.1007/978-3-031-16237-4_6"
}`,
        bibLabel:
          "Secure Design of Cyber-Physical Systems at the Radio Frequency Level: Machine and Deep Learning-Driven Approaches, Challenges and Opportunities",
        doi: "https://link.springer.com/chapter/10.1007/978-3-031-16237-4_6",
      },
    ],
  },

  {
    id: "BTE",
    title: "BLOCKCHAIN TECHNOLOGIES",
    publications: [
      {
        authors: `Zhiyan Chen, Claudio Fiandrino, and Burak Kantarci. "`,
        title: `On blockchain integration into mobile crowdsensing via smart embedded devices: A comprehensive survey.`,
        info: `" Journal of Systems Architecture 115 (2021): 102011. `,
        paperIsRed: true,
        bibtex: `@article{CHEN2021102011,
	title = {On blockchain integration into mobile crowdsensing via smart embedded devices: A comprehensive survey},
	journal = {Journal of Systems Architecture},
	volume = {115},
	pages = {102011},
	year = {2021},
	issn = {1383-7621},
	doi = {https://doi.org/10.1016/j.sysarc.2021.102011},
	url = {https://www.sciencedirect.com/science/article/pii/S1383762121000229},
	author = {Zhiyan Chen and Claudio Fiandrino and Burak Kantarci},
	keywords = {Internet of Things, Mobile crowdsensing, Smart embedded devices, Blockchains, Distributed ledger design},
}`,
        bibLabel: "On blockchain integration into mobile crowdsensing via smart embedded devices: A comprehensive survey",
        doi: "https://www.sciencedirect.com/science/article/abs/pii/S1383762121000229",
      },
    ],
  },

  {
    id: "MC",
    title: "MOBILE CROWDSENSING",
    publications: [
      {
        authors: `A. Capponi, C. Fiandrino, B. Kantarci, L. Foschini, D. Kliazovich and P. Bouvry, "`,
        title: `A Survey on Mobile Crowdsensing Systems: Challenges, Solutions, and Opportunities,`,
        info: `" in IEEE Communications Surveys & Tutorials, vol. 21, no. 3, pp. 2419-2465, Third Quarter 2019 `,
        paperIsRed: true,
        bibtex: `@ARTICLE{8703108,
  author={Capponi, Andrea and Fiandrino, Claudio and Kantarci, Burak and Foschini, Luca and Kliazovich, Dzmitry and Bouvry, Pascal},
  journal={IEEE Communications Surveys & Tutorials}, 
  title={A Survey on Mobile Crowdsensing Systems: Challenges, Solutions, and Opportunities}, 
  year={2019},
  volume={21},
  number={3},
  pages={2419-2465},
  keywords={Sensors;Taxonomy;Tutorials;Smart phones;Data collection;Monitoring;Mobile crowdsensing;urban sensing;opportunistic sensing;participatory sensing},
  doi={10.1109/COMST.2019.2914030}}`,
        bibLabel: "A Survey on Mobile Crowdsensing Systems: Challenges, Solutions, and Opportunities",
        doi: "https://ieeexplore.ieee.org/abstract/document/8703108",
      },
      {
        authors: `Venkat Surya Dasari, Burak Kantarci, Maryam Pouryazdan, Luca Foschini, and Michele Girolami. "`,
        title: `Game theory in mobile crowdsensing: A comprehensive survey. `,
        info: `" Sensors 20, no. 7 (2020): 2055. `,
        paperIsRed: true,
        bibtex: `@Article{s20072055,
	AUTHOR = {Dasari, Venkat Surya and Kantarci, Burak and Pouryazdan, Maryam and Foschini, Luca and Girolami, Michele},
	TITLE = {Game Theory in Mobile CrowdSensing: A Comprehensive Survey},
	JOURNAL = {Sensors},
	VOLUME = {20},
	YEAR = {2020},
	NUMBER = {7},
	ARTICLE-NUMBER = {2055},
	URL = {https://www.mdpi.com/1424-8220/20/7/2055},
	PubMedID = {32268546},
	ISSN = {1424-8220},
	ABSTRACT = {Mobile CrowdSensing (MCS) is an emerging paradigm in the distributed acquisition of smart city and Internet of Things (IoT) data. MCS requires large number of users to enable access to the built-in sensors in their mobile devices and share sensed data to ensure high value and high veracity of big sensed data. Improving user participation in MCS campaigns requires to boost users effectively, which is a key concern for the success of MCS platforms. As MCS builds on non-dedicated sensors, data trustworthiness cannot be guaranteed as every user attains an individual strategy to benefit from participation. At the same time, MCS platforms endeavor to acquire highly dependable crowd-sensed data at lower cost. This phenomenon introduces a game between users that form the participant pool, as well as between the participant pool and the MCS platform. Research on various game theoretic approaches aims to provide a stable solution to this problem. This article presents a comprehensive review of different game theoretic solutions that address the following issues in MCS such as sensing cost, quality of data, optimal price determination between data requesters and providers, and incentives. We propose a taxonomy of game theory-based solutions for MCS platforms in which problems are mainly formulated based on Stackelberg, Bayesian and Evolutionary games. We present the methods used by each game to reach an equilibrium where the solution for the problem ensures that every participant of the game is satisfied with their utility with no requirement of change in their strategies. The initial criterion to categorize the game theoretic solutions for the game theoretic solutions for MCS platforms is based on co-operation and information available among participants whereas a participant could be either a requester or provider. Following a thorough qualitative comparison of the surveyed approaches, we provide insights concerning open areas and possible directions in this active field of research.},
	DOI = {10.3390/s20072055}
}`,
        bibLabel: "Game theory in mobile crowdsensing: A comprehensive survey",
        doi: "https://www.mdpi.com/1424-8220/20/7/2055/htm",
      },
      {
        authors: `D. Belli, S. Chessa, B. Kantarci and L. Foschini,  "`,
        title: `Toward Fog-Based Mobile Crowdsensing Systems: State of the Art and Opportunities,`,
        info: `" in IEEE Communications Magazine, vol. 57, no. 12, pp. 78-83, December 2019  `,
        paperIsRed: true,
        bibtex: `@ARTICLE{8930831,
  author={Belli, Dimitri and Chessa, Stefano and Kantarci, Burak and Foschini, Luca},
  journal={IEEE Communications Magazine}, 
  title={Toward Fog-Based Mobile Crowdsensing Systems: State of the Art and Opportunities}, 
  year={2019},
  volume={57},
  number={12},
  pages={78-83},
  keywords={Edge computing;Crowdsourcing;Distributed databases;Mobile handsets;Cyber-physical systems;Computer architecture;Urban areas},
  doi={10.1109/MCOM.001.1900003}}`,
        bibLabel: "Toward Fog-Based Mobile Crowdsensing Systems: State of the Art and Opportunities",
        doi: "https://ieeexplore.ieee.org/document/8930831",
      },
    ],
  },

  {
    id: "DUC",
    title: "DRONE / UAV COMMUNICATIONS",
    publications: [
      {
        authors: `N. Parvaresh, M. Kulhandjian, H. Kulhandjian, C. D'Amours, B. Kantarci, "`,
        title: `A Tutorial on AI-Powered 3D Deployment of Drone Base Stations: State of the Art, Applications and Challenge,`,
        info: `" Elsevier Vehicular Communications, vol. 36, p. 100474, Aug. 2022.  `,
        paperIsRed: true,
        bibtex: `@article{PARVARESH2022100474,
	title = {A tutorial on AI-powered 3D deployment of drone base stations: State of the art, applications and challenges},
	journal = {Vehicular Communications},
	volume = {36},
	pages = {100474},
	year = {2022},
	issn = {2214-2096},
	doi = {https://doi.org/10.1016/j.vehcom.2022.100474},
	url = {https://www.sciencedirect.com/science/article/pii/S2214209622000213},
	author = {Nahid Parvaresh and Michel Kulhandjian and Hovannes Kulhandjian and Claude D'Amours and Burak Kantarci},
	keywords = {Uncrewed Aerial Vehicles (UAVs), Aerial Base Stations, 5G, Artificial intelligence, Deep neural networks},
}`,
        bibLabel: "A Tutorial on AI-Powered 3D Deployment of Drone Base Stations: State of the Art, Applications and Challenge",
        doi: "https://doi.org/10.1016/j.vehcom.2022.100474",
      },
    ],
  },

  {
    id: "FL",
    title: "FEDERATED LEARNING",
    publications: [
      {
        authors: ` Ji Chu Jiang, Burak Kantarci, Sema Oktug, and Tolga Soyata. "`,
        title: `Federated learning in smart city sensing: Challenges and opportunities.`,
        info: `" Sensors 20, no. 21 (2020): 6230 `,
        paperIsRed: true,
        bibtex: `@Article{s20216230,
	AUTHOR = {Jiang, Ji Chu and Kantarci, Burak and Oktug, Sema and Soyata, Tolga},
	TITLE = {Federated Learning in Smart City Sensing: Challenges and Opportunities},
	JOURNAL = {Sensors},
	VOLUME = {20},
	YEAR = {2020},
	NUMBER = {21},
	ARTICLE-NUMBER = {6230},
	URL = {https://www.mdpi.com/1424-8220/20/21/6230},
	PubMedID = {33142863},
	ISSN = {1424-8220},
	DOI = {10.3390/s20216230}
}`,
        bibLabel: "Federated Learning in Smart City Sensing: Challenges and Opportunities",
        doi: "https://www.mdpi.com/1424-8220/20/21/6230",
      },
    ],
  },

  {
    id: "CSE",
    title: "COMMUNICATIONS & CYBER SECURITY",
    publications: [
      {
        authors: ` P. Lohan, B. Kantarci, M. Ferrag, N. Tihanyi, Y. Shi, "`,
        title: `From 5G to 6G Networks: A Survey on AI-Based Jamming and Interference Detection and Mitigation`,
        info: `" IEEE Open Journal of the Communications Society, pp. 3920-3974, 2024.`,
        paperIsRed: true,
        bibtex: `@ARTICLE{10564152,
  author={Lohan, Poonam and Kantarci, Burak and Amine Ferrag, Mohamed and Tihanyi, Norbert and Shi, Yi},
  journal={IEEE Open Journal of the Communications Society}, 
  title={From 5G to 6G Networks: A Survey on AI-Based Jamming and Interference Detection and Mitigation}, 
  year={2024},
  volume={5},
  number={},
  pages={3920-3974},
  keywords={Interference;5G mobile communication;6G mobile communication;Surveys;Internet of Things;Artificial intelligence;3GPP;5G;6G;artificial intelligence;machine learning;jamming detection;jamming mitigation;interference mitigation;physical layer},
  doi={10.1109/OJCOMS.2024.3416808}}`,
        bibLabel: "From 5G to 6G Networks: A Survey on AI-Based Jamming and Interference Detection and Mitigation",
        doi: "https://ieeexplore.ieee.org/document/10564152",
      },
      {
        authors: ` M. A. Ferrag, O. Friha, B. Kantarci, N. Tihanyi, L. Cordeiro, M. Debbah, D. Hamouda, M. Al-Hawawreh, K-K. Raymond Choo,"`,
        title: `Edge Learning for 6G-enabled Internet of Things: A Comprehensive Survey of Vulnerabilities, Datasets, and Defenses`,
        info: `" IEEE Communications Surveys and Tutorials, vol, 25, issue 4, pp. 2654 2713, Fourth Quarter 2023`,
        paperIsRed: true,
        bibtex: `@ARTICLE{10255264,
  author={Ferrag, Mohamed Amine and Friha, Othmane and Kantarci, Burak and Tihanyi, Norbert and Cordeiro, Lucas and Debbah, Merouane and Hamouda, Djallel and Al-Hawawreh, Muna and Choo, Kim-Kwang Raymond},
  journal={IEEE Communications Surveys & Tutorials}, 
  title={Edge Learning for 6G-Enabled Internet of Things: A Comprehensive Survey of Vulnerabilities, Datasets, and Defenses}, 
  year={2023},
  volume={25},
  number={4},
  pages={2654-2713},
  keywords={6G mobile communication;Security;Internet of Things;Surveys;Peer-to-peer computing;Image edge detection;Federated learning;Edge learning;6G;IoT;federated learning;AI vulnerabilities;security},
  doi={10.1109/COMST.2023.3317242}}`,
        bibLabel: "Edge Learning for 6G-enabled Internet of Things: A Comprehensive Survey of Vulnerabilities, Datasets, and Defenses",
        doi: "https://ieeexplore.ieee.org/document/10255264",
      },
      {
        authors: ` A. B. de Neira, B. Kantarci, M. Nogueira, "`,
        title: `Distributed denial of service attack prediction: Challenges, open issues and opportunities,`,
        info: `" Elsevier Computer Networks, volume 222, p. 1095532023, February 2023,`,
        paperIsRed: true,
        bibtex: `@article{DENEIRA2023109553,
	title = {Distributed denial of service attack prediction: Challenges, open issues and opportunities},
	journal = {Computer Networks},
	volume = {222},
	pages = {109553},
	year = {2023},
	issn = {1389-1286},
	doi = {https://doi.org/10.1016/j.comnet.2022.109553},
	url = {https://www.sciencedirect.com/science/article/pii/S1389128622005874},
	author = {Anderson Bergamini {de Neira} and Burak Kantarci and Michele Nogueira},
	keywords = {Cybersecurity, DDoS attack prediction, Survey, Network security},
}`,
        bibLabel: "Distributed denial of service attack prediction: Challenges, open issues and opportunities",
        doi: "https://www.sciencedirect.com/science/article/abs/pii/S1389128622005874",
      },
      {
        authors: ` Jinxin Liu, Michele Nogueira, Johan Fernandes and Burak Kantarci, "`,
        title: `Adversarial Machine Learning: A Multilayer Review of the State-of-the-Art and Challenges for Wireless and Mobile Systems,`,
        info: `" in IEEE Communications Surveys & Tutorials, vol. 24, no. 1, pp. 123-159, First Quarter 2022 `,
        paperIsRed: true,
        bibtex: `@ARTICLE{9653662,
  author={Liu, Jinxin and Nogueira, Michele and Fernandes, Johan and Kantarci, Burak},
  journal={IEEE Communications Surveys & Tutorials}, 
  title={Adversarial Machine Learning: A Multilayer Review of the State-of-the-Art and Challenges for Wireless and Mobile Systems}, 
  year={2022},
  volume={24},
  number={1},
  pages={123-159},
  keywords={Wireless communication;Communication system security;Malware;Feature extraction;Wireless sensor networks;Intrusion detection;Generative adversarial networks;Wireless networks;mobile networks;adversarial machine learning;artificial intelligence;intrusion detection},
  doi={10.1109/COMST.2021.3136132}}`,
        bibLabel: "Adversarial Machine Learning: A Multilayer Review of the State-of-the-Art and Challenges for Wireless and Mobile Systems",
        doi: "https://ieeexplore.ieee.org/document/9653662",
      },
      {
        authors: ` Z. Chen, J. Liu, Y. Shen, M. Simsek, B. Kantarci, H. T. Mouftah, P. Djukic, "`,
        title: `Machine Learning-Enabled IoT Security: Open Issues and Challenges Under Advanced Persistent Threats,`,
        info: `" ACM Computing Surveys, vol. 55/5, pp. 1--37, 2022 `,
        paperIsRed: true,
        bibtex: `@article{10.1145/3530812,
author = {Chen, Zhiyan and Liu, Jinxin and Shen, Yu and Simsek, Murat and Kantarci, Burak and Mouftah, Hussein T. and Djukic, Petar},
title = {Machine Learning-Enabled IoT Security: Open Issues and Challenges Under Advanced Persistent Threats},
year = {2022},
issue_date = {May 2023},
publisher = {Association for Computing Machinery},
address = {New York, NY, USA},
volume = {55},
number = {5},
issn = {0360-0300},
url = {https://doi.org/10.1145/3530812},
doi = {10.1145/3530812},
abstract = {Despite its technological benefits, the Internet of Things (IoT) has cyber weaknesses due to vulnerabilities in the wireless medium. Machine Larning (ML)-based methods are widely used against cyber threats in IoT networks with promising performance. An Advanced Persistent Threat (APT) is prominent for cybercriminals to compromise networks, and it is crucial to long-term and harmful characteristics. However, it is difficult to apply ML-based approaches to identify APT attacks to obtain a promising detection performance due to an extremely small percentage among normal traffic. There are limited surveys that fully investigate APT attacks in IoT networks due to the lack of public datasets with all types of APT attacks. It is worth bridging the state of the art in network attack detection with APT attack detection in a comprehensive review article. This survey article reviews the security challenges in IoT networks and presents well-known attacks, APT attacks, and threat models in IoT systems. Meanwhile, signature-based, anomaly-based, and hybrid intrusion detection systems are summarized for IoT networks. The article highlights statistical insights regarding frequently applied ML-based methods against network intrusion. Finally, open issues and challenges for common network intrusion and APT attacks are presented for future research.},
journal = {ACM Comput. Surv.},
month = dec,
articleno = {105},
numpages = {37},
keywords = {Internet of Things, cyberattack, network security, network intrusion detection, machine learning, deep learning}
}`,
        bibLabel: "Machine Learning-Enabled IoT Security: Open Issues and Challenges Under Advanced Persistent Threats",
        doi: "https://doi.org/10.1145/3530812",
      },
      {
        authors: ` Comert, C., Gul, O. M., Kulhandjian, M., Touazi, A., Ellement, C., Kantarci, B., & D'Amours, C. (2022). "`,
        title: `Secure Design of Cyber-Physical Systems at the Radio Frequency Level: Machine and Deep Learning-Driven Approaches, Challenges and Opportunities.`,
        info: `" Artificial Intelligence for Cyber-Physical Systems Hardening, 123-154. `,
        paperIsRed: true,
        bibtex: `@Inbook{Comert2023,
	author="Comert, Ceren
	and Gul, Omer Melih
	and Kulhandjian, Michel
	and Touazi, Azzedine
	and Ellement, Cliff
	and Kantarci, Burak
	and D'Amours, Claude",
	editor="Traore, Issa
	and Woungang, Isaac
	and Saad, Sherif",
	title="Secure Design of Cyber-Physical Systems at the Radio Frequency Level: Machine and Deep Learning-Driven Approaches, Challenges and Opportunities",
	bookTitle="Artificial Intelligence for Cyber-Physical Systems Hardening",
	year="2023",
	publisher="Springer International Publishing",
	address="Cham",
	pages="123--154",
	isbn="978-3-031-16237-4",
	doi="10.1007/978-3-031-16237-4_6",
	url="https://doi.org/10.1007/978-3-031-16237-4_6"
}`,
        bibLabel:
          "Secure Design of Cyber-Physical Systems at the Radio Frequency Level: Machine and Deep Learning-Driven Approaches, Challenges and Opportunities",
        doi: "https://link.springer.com/content/pdf/10.1007/978-3-031-16237-4_6.pdf?pdf=inline%20link",
      },
      {
        authors: ` Habibzadeh, Hadi, Brian H. Nussbaum, Fazel Anjomshoa, Burak Kantarci, and Tolga Soyata.  "`,
        title: `A survey on cybersecurity, data privacy, and policy issues in cyber-physical system deployments in smart cities.`,
        info: `" ElsevierSustainable Cities and Society 50 (2019): 101660. `,
        paperIsRed: true,
        bibtex: `@article{HABIBZADEH2019101660,
	title = {A survey on cybersecurity, data privacy, and policy issues in cyber-physical system deployments in smart cities},
	journal = {Sustainable Cities and Society},
	volume = {50},
	pages = {101660},
	year = {2019},
	issn = {2210-6707},
	doi = {https://doi.org/10.1016/j.scs.2019.101660},
	url = {https://www.sciencedirect.com/science/article/pii/S2210670718316883},
	author = {Hadi Habibzadeh and Brian H. Nussbaum and Fazel Anjomshoa and Burak Kantarci and Tolga Soyata},
	keywords = {Smart cities, Cyber security, Government policy making, Cryptography, Security and privacy, Authentication},
}`,
        bibLabel: "A survey on cybersecurity, data privacy, and policy issues in cyber-physical system deployments in smart cities",
        doi: "https://www.sciencedirect.com/science/article/pii/S2210670718316883?casa_token=A0t2F07BDTEAAAAA:MYjxb_PoJ5hN8rpxxTYoVC-KHhHr4SsamxFJytD7mxzyH0mi9yl-phP_2rUgbtH8dJc-es6hKPCg",
      },
      {
        authors: ` Quintal, Kyle, Burak Kantarci, Melike Erol-Kantarci, Andrew Malton, and Andrew Walenstein. "`,
        title: `Contextual, behavioral, and biometric signatures for continuous authentication.`,
        info: `" IEEE Internet Computing 23, no. 5 (2019): 18-28. `,
        paperIsRed: true,
        bibtex: `@ARTICLE{8836081,
  author={Quintal, Kyle and Kantarci, Burak and Erol-Kantarci, Melike and Malton, Andrew and Walenstein, Andrew},
  journal={IEEE Internet Computing}, 
  title={Contextual, Behavioral, and Biometric Signatures for Continuous Authentication}, 
  year={2019},
  volume={23},
  number={5},
  pages={18-28},
  keywords={Authentication;Sensors;Machine learning;Face recognition;Social networking (online);Internet;Cybersecurity;Context Recognition;Biometric Authentication;Machine Intelligence;Data Analytics;Behaviometrics;Continuous Authentication},
  doi={10.1109/MIC.2019.2941391}}`,
        bibLabel: "Contextual, Behavioral, and Biometric Signatures for Continuous Authentication",
        doi: "https://doi.org/10.1109/MIC.2019.2941391",
      },
    ],
  },

  {
    id: "SC",
    title: "SMART CITIES & AUTONOMOUS TECHNOLOGIES",
    publications: [
      {
        authors: ` Lansu Dai, and Burak Kantarci "`,
        title: `A Survey on Enhancing Autonomous Vehicle Safety through Fault Tree Analysis and SOTIF Integration.`,
        info: `" ACM Journal on Autonomous Transportation Systems. 2026.`,
        paperIsRed: true,
        bibtex: `@article{10.1145/3787221,
 author = {Dai, Lansu and Kantarci, Burak},
 title = {A Survey on Enhancing Autonomous Vehicle Safety through Fault Tree Analysis and SOTIF Integration},
 year = {2026},
 publisher = {Association for Computing Machinery},
 address = {New York, NY, USA},
 url = {https://doi.org/10.1145/3787221},
 doi = {10.1145/3787221},
 note = {Just Accepted},
 journal = {ACM J. Auton. Transport. Syst.},
 month = jan,
 keywords = {Fault Tree Analysis, Safety of the Intended Functionality, Autonomous Vehicles}
}`,
        bibLabel: "A Survey on Enhancing Autonomous Vehicle Safety through Fault Tree Analysis and SOTIF Integration",
        doi: "https://dl.acm.org/doi/10.1145/3787221",
      },
      {
        authors: ` Habibzadeh, Hadi, Cem Kaptan, Tolga Soyata, Burak Kantarci, and Azzedine Boukerche. "`,
        title: `Smart city system design: A comprehensive study of the application and data planes.`,
        info: `" ACM Computing Surveys (CSUR) 52, no. 2 (2019): 1-38.`,
        paperIsRed: true,
        bibtex: `@article{10.1145/3309545,
    author = {Habibzadeh, Hadi and Kaptan, Cem and Soyata, Tolga and Kantarci, Burak and Boukerche, Azzedine},
    title = {Smart City System Design: A Comprehensive Study of the Application and Data Planes},
    year = {2019},
    issue_date = {March 2020},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    volume = {52},
    number = {2},
    issn = {0360-0300},
    url = {https://doi.org/10.1145/3309545},
    doi = {10.1145/3309545},
    abstract = {Recent global smart city efforts resemble the establishment of electricity networks when electricity was first invented, which meant the start of a new era to sell electricity as a utility. A century later, in the smart era, the network to deliver services goes far beyond a single entity like electricity. Supplemented by a well-established Internet infrastructure that can run an endless number of applications, abundant processing and storage capabilities of clouds, resilient edge computing, and sophisticated data analysis like machine learning and deep learning, an already-booming Internet of Things movement makes this new era far more exciting.In this article, we present a multi-faceted survey of machine intelligence in modern implementations. We partition smart city infrastructure into application, sensing, communication, security, and data planes and put an emphasis on the data plane as the mainstay of computing and data storage. We investigate (i) a centralized and distributed implementation of data plane’s physical infrastructure and (ii) a complementary application of data analytics, machine learning, deep learning, and data visualization to implement robust machine intelligence in a smart city software core. We finalize our article with pointers to open issues and challenges.},
    journal = {ACM Comput. Surv.},
    month = may,
    articleno = {41},
    numpages = {38},
    keywords = {Crowdsensing, and prescriptive analytics, big data, cybersecurity, data science, deep learning, diagnostic, edge-computing, mobile computing, predictive, smart sustainable cities, supervised learning, unsupervised learning}
}`,
        bibLabel: "Smart City System Design: A Comprehensive Study of the Application and Data Planes",
        doi: "https://dl.acm.org/doi/abs/10.1145/3309545",
      },
      {
        authors: ` Habibzadeh, Hadi, Tolga Soyata, Burak Kantarci, Azzedine Boukerche, and Cem Kaptan. "`,
        title: `Sensing, communication and security planes: A new challenge for a smart city system design.`,
        info: `" Computer Networks 144 (2018): 163-200.`,
        paperIsRed: true,
        bibtex: `@article{HABIBZADEH2018163,
	title = {Sensing, communication and security planes: A new challenge for a smart city system design},
	journal = {Computer Networks},
	volume = {144},
	pages = {163-200},
	year = {2018},
	issn = {1389-1286},
	doi = {https://doi.org/10.1016/j.comnet.2018.08.001},
	url = {https://www.sciencedirect.com/science/article/pii/S1389128618306534},
	author = {Hadi Habibzadeh and Tolga Soyata and Burak Kantarci and Azzedine Boukerche and Cem Kaptan},
	keywords = {Smart cities, Smart spaces, Security, 5G networks and communication, Edge networks, Internet of Things, Dedicated sensing, Non-dedicated sensing},
}`,
        bibLabel: "Sensing, communication and security planes: A new challenge for a smart city system design",
        doi: "https://www.sciencedirect.com/science/article/pii/S1389128618306534?casa_token=c1M-9vFJkfAAAAAA:L4aSWaj_uj0iYbWREaWYngpeZBI_tTH9DwLA19j7Bq5Ts9vP0FJ3oUiOebdLOhxagftG8Vfvxnva",
      },
      {
        authors: ` Habibzadeh, Hadi, Andrew Boggio-Dandry, Zhou Qin, Tolga Soyata, Burak Kantarci, and Hussein T. Mouftah. "`,
        title: `Soft sensing in smart cities: Handling 3Vs using recommender systems, machine intelligence, and data analytics.`,
        info: `" IEEE Communications Magazine 56, no. 2 (2018): 78-86. `,
        paperIsRed: true,
        bibtex: `@ARTICLE{8291118,
  author={Habibzadeh, Hadi and Boggio-Dandry, Andrew and Qin, Zhou and Soyata, Tolga and Kantarci, Burak and Mouftah, Hussein T.},
  journal={IEEE Communications Magazine}, 
  title={Soft Sensing in Smart Cities: Handling 3Vs Using Recommender Systems, Machine Intelligence, and Data Analytics}, 
  year={2018},
  volume={56},
  number={2},
  pages={78-86},
  keywords={Intelligent sensors;Smart cities;Sensor systems;Recommender systems;Data analysis;Big Data},
  doi={10.1109/MCOM.2018.1700304}}`,
        bibLabel: "Soft Sensing in Smart Cities: Handling 3Vs Using Recommender Systems, Machine Intelligence, and Data Analytics",
        doi: "https://ieeexplore.ieee.org/abstract/document/8291118?casa_token=9mkJywoiXKUAAAAA:Qdi00oiTNNekr83S4Lyn7GS9SVXtIUGSiqh9ZEHxcZmZhplAV-30jtGtp9eFNm0FO9_EDPJho1Vs",
      },
    ],
  },

  {
    id: "DRO",
    title: "DISASTER RESILIENCE & OPTICAL ACCESS NETWORKS",
    titleMobile: "DISASTER RESILIENCE & \n OPTICAL ACCESS NETWORKS",
    publications: [
      {
        authors: ` D. Cicek and B. Kantarci, "`,
        title: `Use of Mobile Crowdsensing in Disaster Management: A Systematic Review, Challenges, and Open Issues,`,
        info: `" Sensors, 23(3):1699, Jan 2023.`,
        paperIsRed: true,
        bibtex: `@Article{s23031699,
	AUTHOR = {Cicek, Didem and Kantarci, Burak},
	TITLE = {Use of Mobile Crowdsensing in Disaster Management: A Systematic Review, Challenges, and Open Issues},
	JOURNAL = {Sensors},
	VOLUME = {23},
	YEAR = {2023},
	NUMBER = {3},
	ARTICLE-NUMBER = {1699},
	URL = {https://www.mdpi.com/1424-8220/23/3/1699},
	PubMedID = {36772738},
	ISSN = {1424-8220},
	DOI = {10.3390/s23031699}
}`,
        bibLabel: "Use of Mobile Crowdsensing in Disaster Management: A Systematic Review, Challenges, and Open Issues",
        doi: "https://www.mdpi.com/1424-8220/23/3/1699",
      },
      {
        authors: ` Rak, Jacek, Rita Girão-Silva, Teresa Gomes, Georgios Ellinas, Burak Kantarci, and Massimo Tornatore. "`,
        title: `Disaster resilience of optical networks: State of the art, challenges, and opportunities.`,
        info: `" Optical Switching and Networking 42 (2021): 100619. `,
        paperIsRed: true,
        bibtex: `@article{RAK2021100619,
	title = {Disaster resilience of optical networks: State of the art, challenges, and opportunities},
	journal = {Optical Switching and Networking},
	volume = {42},
	pages = {100619},
	year = {2021},
	issn = {1573-4277},
	doi = {https://doi.org/10.1016/j.osn.2021.100619},
	url = {https://www.sciencedirect.com/science/article/pii/S1573427721000163},
	author = {Jacek Rak and Rita Girão-Silva and Teresa Gomes and Georgios Ellinas and Burak Kantarci and Massimo Tornatore},
	keywords = {Optical networks, Resilience, 5G and beyond, Content connectivity, Data evacuation, Datacenters, Failure recovery, Fixed-mobile convergence, Malicious attacks, Manycast, Natural disasters, Network availability, Post-disaster modeling, Post-disaster recovery, Power disruptions, Weather-based disruptions},
}`,
        bibLabel: "Disaster resilience of optical networks: State of the art, challenges, and opportunities",
        doi: "https://www.sciencedirect.com/science/article/pii/S1573427721000163",
      },
      {
        authors: ` Kantarci, Burak, and Hussein T. Mouftah. "`,
        title: `Bandwidth distribution solutions for performance enhancement in long-reach passive optical networks.`,
        info: `" IEEE Communications Surveys & Tutorials 14, no. 3 (2011): 714-733.`,
        paperIsRed: true,
        bibtex: `@ARTICLE{6007074,
  author={Kantarci, Burak and Mouftah, Hussein T.},
  journal={IEEE Communications Surveys & Tutorials}, 
  title={Bandwidth Distribution Solutions for Performance Enhancement in Long-Reach Passive Optical Networks}, 
  year={2012},
  volume={14},
  number={3},
  pages={714-733},
  keywords={Delay;Passive optical networks;EPON;Optical network units;IEEE 802.3 Standards;Bandwidth;Wavelength division multiplexing;Passive optical networks;long-reach PON;dynamic bandwidth assignment;multi-server polling systems;next generation PON;performance enhancement},
  doi={10.1109/SURV.2011.081511.00013}}`,
        bibLabel: "Bandwidth Distribution Solutions for Performance Enhancement in Long-Reach Passive Optical Networks",
        doi: "https://doi.org/10.1109/SURV.2011.081511.00013",
      },
    ],
  },
];